/* Burned Sports custom (registry #71, 12-10): Elite-sok, kleurwissel + pakkiezer "3 voor de prijs van 2".
   Markup: snippets/burned-sock-kleur.liquid, snippets/burned-sock-pack.liquid (twee delen: 'kaarten' en 'koop')
   en snippets/burned-sock-maathulp.liquid. Geladen door het blok bn_sok_assets in templates/product.elite-sock.json.

   Foutbestendig (Salomon 12-10): Wonder's eigen maatkiezer en koopknop blijven altijd werken. De pakkiezer
   staat op `hidden` tot init() zonder fouten klaar is; gaat er iets mis, dan blijft hij weg en is het een
   gewone productpagina. Toevoegen gaat in één /cart/add.js-aanroep (zelfde weg als shoppable-buy-all.js);
   lukt de winkelwagenlade niet, dan naar /cart. Nooit half toevoegen, nooit stil een andere maat.

   Burned 14-10 (registry #71 r3, de mockup die Salomon goedkeurde):
   - Geen maat vooraf ("enable-preselected-variant": false). Wonder laat dan wel de eerste leverbare variant (nu S)
     in het verborgen veld name="id" staan; dat is dus géén keuze van de klant. De gekozen maat = de aangevinkte
     maatknop in Wonder's variant-options. Daar kijken kleurwissel en pakkiezer naar, nooit meer naar name="id".
   - "3 paar" staat standaard aan (HTML); de maatknoppen blijven in beide standen staan en één maatkeuze vult
     alle drie de paren. Zonder maat staan de paren op "Kies kleur en maat" en zeggen beide knoppen "Kies je maat".
   - Kleurwissel in 3-paar-modus: zelf aangepaste paren gaan mee als #3-paar=id,id,id; in 1-paar-modus #1-paar.
   - Desktop: de infokolom loopt mee (CSS-variabelen --bn-kop-h en --bn-kolom-h, zie burned-sock.css).

   Burned 14-10, registry #71 r3 (review-fixes):
   - Een maatknop vult altijd alle drie de paren, ook na "per paar aanpassen" of een #3-paar=id,id,id-hash
     (anders kon er een andere maat in de winkelwagen komen dan de klant zag). Zelf aangepaste paren gaan bij een
     kleurwissel nog wel mee.
   - 1 paar zonder maat: Wonder's knop blijft disabled (een echte submit zonder maat kan niet), maar is zwart
     (klasse bn-sok-kies-maat, alleen door dit script) en een klik zegt "Kies eerst je maat." en scrolt naar de
     maatknoppen. Zonder script blijft het Wonder's grijze knop.
   - Vangnet ook ná het opstarten: gooit een handler van de pakkiezer een fout, dan dezelfde terugval als bij een
     opstartfout (pakkiezer weg, Wonder's koopknop en aantalkiezer terug).
   - Submit-wacht (capture op document): in 3-paar-stand of zonder aangevinkte maat gaat Wonder's productformulier
     niet de deur uit. Zit alleen in dit script: valt het weg, dan werkt Wonder gewoon.
   - Gekozen maat die in deze kleur op is: "Deze maat is op in deze kleur." in plaats van "Kies eerst je maat.".
   - Sticky balk in 3-paar-stand: niets onderscheppen als "Houd me op de hoogte" zichtbaar is.
   - Helemaal uitverkocht (alle maatknoppen doorgestreept): Wonder's eigen knop en tekst, niets aanpassen.
   - de/fr: de maatnaam achter "Sokmaten EU:" ook leeg zonder gekozen maat; alleen de knoptekst blijft nl/en. */
(function () {
  'use strict';
  if (window.bnSokGeladen) return; /* vangnet: mocht de tag toch twee keer in de pagina staan */
  window.bnSokGeladen = true;

  var html = document.documentElement;

  /* De maat die de klant koos: de waarde van de aangevinkte maatknop ("M 38-42"), of '' als er nog niets
     gekozen is. Het verborgen veld name="id" telt niet: daar zet Wonder zonder voorkeuze zelf de eerste leverbare
     variant in. */
  function gekozenMaat(info) {
    var r = info && info.querySelector('variant-options input[type="radio"]:checked');
    return r ? String(r.value) : '';
  }

  /* 14-10, registry #71 r3: heeft deze productkolom Wonder's maatknoppen (radio's)? Zonder radio's (ander type
     maatkiezer) weten we niet wat "geen maat" is, en dan blokkeren we ook niets. */
  function heeftMaatknoppen(info) {
    return !!(info && info.querySelector('variant-options input[type="radio"]'));
  }

  /* 14-10, registry #71 r3: alle maatknoppen doorgestreept (Wonder zet class="disabled" op een maat die nergens
     leverbaar is) = het product is helemaal uitverkocht. */
  function allesOp(info) {
    var r = info ? info.querySelectorAll('variant-options input[type="radio"]') : [];
    if (!r.length) return false;
    return Array.prototype.every.call(r, function (x) { return x.classList.contains('disabled'); });
  }

  function rustig() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* "titel|id;titel|id;" → { titel: id } */
  function leesMaten(tekst) {
    var uit = {};
    (tekst || '').split(';').forEach(function (r) {
      var d = r.split('|');
      if (d.length === 2 && d[0]) uit[d[0]] = d[1];
    });
    return uit;
  }

  /* De pakkiezer geeft hier door wat er bij een kleurwissel achter de link moet (#1-paar, #3-paar of
     #3-paar=id,id,id). Zonder pakkiezer (live-slot uit, of het script viel om) blijft dit leeg. */
  var pakHash = function () { return ''; };
  /* 14-10, registry #71 r3: staat de pakkiezer op 3 paar? Leest de submit-wacht. Zonder pakkiezer: nooit. */
  var pakDrie = function () { return false; };
  /* 14-10, registry #71 r3: toont "Kies eerst je maat." boven Wonder's knop (zet initKiesMaat); anders niets. */
  var meldKiesMaat = function () {};

  /* ---------- Kleurwissel: dezelfde maat meenemen naar de andere kleur ---------- */
  function initKleur(blok) {
    var info = blok.closest('.wt-product__info');
    blok.querySelectorAll('a[data-bn-sok-ander]').forEach(function (a) {
      var maten = leesMaten(a.getAttribute('data-bn-maten'));
      var basis = a.getAttribute('href');
      function doel() {
        var maat = gekozenMaat(info);
        var url = basis;
        if (maat && maten[maat]) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + maten[maat];
        return url + pakHash();
      }
      a.addEventListener('click', function (e) {
        try {
          var url = doel();
          if (url !== basis) {
            e.preventDefault();
            window.location.href = url;
          }
        } catch (err) { /* gewoon de link volgen */ }
      });
      /* Vooraf laden, dan voelt de wissel direct. Burned 14-10 (r3): dezelfde URL als de klik (met ?variant=);
         eerst werd de kale link opgehaald en die gebruikte de klik nooit. */
      a.addEventListener('pointerenter', function () {
        try {
          if (a.dataset.bnVooraf) return;
          a.dataset.bnVooraf = '1';
          var l = document.createElement('link');
          l.rel = 'prefetch';
          l.href = doel();
          document.head.appendChild(l);
        } catch (err) {}
      }, { once: true });
    });
  }

  /* ---------- Wonder's koopknop zonder maat: "Kies je maat" (r3) ----------
     Wonder zegt dan "Selecteer een optie". Alleen de tekst (en het aria-label) zolang er niets gekozen is; bij de
     eerste maatkeuze zet Wonder zijn eigen tekst en zetten wij het aria-label terug. Valt dit script uit, dan blijft
     Wonder's eigen tekst staan. De tekst per taal staat op de maathulp (data-bn-kies-maat; nl en en).

     14-10, registry #71 r3 (review-fixes):
     - De maatnaam achter "Sokmaten EU:" gaat in elke taal leeg zolang er niets gekozen is (Wonder zet er anders de
       eerste leverbare maat neer); alleen de knoptekst blijft nl/en (data-bn-kies-maat).
     - Wonder's knop blijft disabled, maar wordt zwart (klasse bn-sok-kies-maat op de productkolom; CSS in
       burned-sock.css zet pointer-events uit, zodat de klik bij de wrapper eronder aankomt). Een klik op de knop
       toont "Kies eerst je maat." (data-bn-kies-eerst, zelfde tekst en stijl als bij de pakknop) en scrolt naar de
       maatknoppen. Bij de eerste maatkeuze gaat de klasse eraf: dan is het weer gewoon Wonder.
     - Helemaal uitverkocht (alle maatknoppen doorgestreept): niets aanpassen, Wonder's eigen "uitverkocht". */
  function initKiesMaat(hulp) {
    var tekst = hulp.getAttribute('data-bn-kies-maat');
    var eerst = hulp.getAttribute('data-bn-kies-eerst');
    var info = hulp.closest('.wt-product__info');
    var opties = info && info.querySelector('variant-options');
    if (!opties || !heeftMaatknoppen(info) || gekozenMaat(info) || allesOp(info)) return;
    /* Zonder gekozen maat ook geen maatnaam achter "Sokmaten EU:" (alle talen) */
    var waarde = opties.querySelector('.wt-product__option__title .value');
    if (waarde) waarde.textContent = '';
    var knop = info.querySelector('.main-product__buy-buttons--container [name="add"]');
    var label = knop && knop.querySelector('.wt-btn__label span');
    if (!label || !knop.disabled) return;
    var aria = knop.getAttribute('aria-label');
    if (tekst) {
      label.textContent = tekst;
      knop.setAttribute('aria-label', tekst);
    }

    var houder = knop.closest('.main-product__buy-buttons--container');
    var melding = null;
    if (eerst && houder && houder.parentNode) {
      melding = document.createElement('p');
      melding.className = 'bn-sok-pak__fout bn-sok-kies-fout';
      melding.setAttribute('role', 'alert');
      houder.parentNode.insertBefore(melding, houder);
      meldKiesMaat = function () {
        if (gekozenMaat(info)) return;
        melding.textContent = eerst;
        var doel = info.querySelector('[data-block-id="variant_picker"]') || opties;
        doel.scrollIntoView({ behavior: rustig() ? 'auto' : 'smooth', block: 'center' });
      };
      houder.addEventListener('click', function (e) {
        try {
          if (!info.classList.contains('bn-sok-kies-maat') || !knop.disabled || gekozenMaat(info)) return;
          var r = knop.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
          meldKiesMaat();
        } catch (err) { console.warn('burned-sock kies je maat', err); }
      });
      info.classList.add('bn-sok-kies-maat');
    }

    opties.addEventListener('change', function () {
      if (tekst) {
        if (aria !== null) knop.setAttribute('aria-label', aria);
        else knop.removeAttribute('aria-label');
      }
      info.classList.remove('bn-sok-kies-maat');
      if (melding) melding.textContent = '';
      meldKiesMaat = function () {};
    }, { once: true });
  }

  /* ---------- Desktop (≥ 990px): de infokolom loopt mee (r3) ----------
     burned-sock.css zet .wt-product__main op sticky met top = min(header + 24, 100vh − kolom − 24): past de kolom
     in beeld, dan blijft hij onder de header staan; is hij langer, dan schuift hij mee tot zijn onderkant in beeld
     is. Dit zet alleen de twee maten; zonder script valt de CSS terug op "sticky onder de header". */
  function initKolom(info) {
    var kolom = info.closest('.wt-product__main');
    if (!kolom) return;
    var kop = document.querySelector('header.page-header, .shopify-section-group-header-group.page-header');
    function maten() {
      kolom.style.setProperty('--bn-kolom-h', Math.ceil(kolom.getBoundingClientRect().height) + 'px');
      if (kop) html.style.setProperty('--bn-kop-h', Math.ceil(kop.getBoundingClientRect().height) + 'px');
    }
    maten();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(maten);
      ro.observe(kolom);
      if (kop) ro.observe(kop);
    }
    window.addEventListener('resize', maten);
  }

  /* ---------- Geld: formaat afleiden uit Shopify's eigen money-filter ---------- */
  function maakGeld(voorbeeld) {
    var m = /^([^0-9]*)1([^0-9]?)234([^0-9])56([^0-9]*)$/.exec((voorbeeld || '').trim());
    if (m) {
      return function (centen) {
        var heel = String(Math.floor(centen / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
        var rest = String(centen % 100);
        if (rest.length < 2) rest = '0' + rest;
        return m[1] + heel + m[3] + rest + m[4];
      };
    }
    var munt = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (munt && window.Intl) {
      var nf = new Intl.NumberFormat(html.lang || undefined, { style: 'currency', currency: munt });
      return function (centen) { return nf.format(centen / 100); };
    }
    return null; /* dan blijven de bedragen uit Liquid staan */
  }

  /* ---------- Pakkiezer ----------
     blok = deel 'kaarten' ("Hoeveel paar?", boven de maatknoppen), koop = deel 'koop' (per paar aanpassen, pakknop,
     kortingsregel; onder de maathulp). Beide komen uit snippets/burned-sock-pack.liquid. */
  function initPak(blok) {
    var info = blok.closest('.wt-product__info');
    var koop = info && info.querySelector('[data-bn-sok-pak-koop]');
    var radios = blok.querySelectorAll('input[data-bn-aantal]');
    var paren = koop && koop.querySelector('[data-bn-paren]');
    var keuzes = koop ? koop.querySelectorAll('select[data-bn-paar]') : [];
    var knop = koop && koop.querySelector('[data-bn-knop]');
    var knopTekst = koop && koop.querySelector('[data-bn-knop-tekst]');
    var fout = koop && koop.querySelector('[data-bn-fout]');
    var prijs3 = blok.querySelector('[data-bn-prijs-3]');
    var prijsWas = blok.querySelector('[data-bn-prijs-was]');
    var bespaar = blok.querySelector('[data-bn-bespaar]');
    var perPaar = blok.querySelector('[data-bn-perpaar]');
    var t = JSON.parse(blok.querySelector('[data-bn-sok-tekst]').textContent);
    var geldEl = blok.querySelector('[data-bn-geld]');
    var geld = maakGeld(geldEl ? geldEl.textContent : '');
    var eigen = leesMaten(blok.getAttribute('data-bn-eigen'));
    if (!info || !koop || radios.length !== 2 || !paren || keuzes.length !== 3 || !knop || !knopTekst || !fout ||
        !info.querySelector('variant-options')) {
      throw new Error('burned-sock: pakkiezer onvolledig');
    }

    var aangeraakt = false; /* de klant paste zelf een paar aan in de uitklapper */
    var bezig = false;
    var drie = false;
    var kapot = false;

    /* 14-10, registry #71 r3: vangnet ook ná het opstarten. Elke handler en rekenstap loopt hierdoor; gooit een ervan
       een fout, dan dezelfde terugval als bij een opstartfout (terugval() hieronder: pakkiezer weg, Wonder's
       koopknop en aantalkiezer terug) en doet de pakkiezer daarna niets meer. Een fout in de klikhandler valt altijd
       vóór de fetch (alles erna is async en heeft eigen catches), dus er gaat nooit half iets de winkelwagen in. */
    function veilig(fn) {
      return function () {
        if (kapot) return undefined;
        try {
          return fn.apply(this, arguments);
        } catch (err) {
          kapot = true;
          terugval(blok, err);
          return undefined;
        }
      };
    }

    function gekozen() {
      return Array.prototype.map.call(keuzes, function (s) {
        var o = s.options[s.selectedIndex];
        return o && o.value && !o.disabled ? o : null;
      });
    }

    function toonFout(tekst) {
      fout.textContent = tekst || '';
    }

    /* Prijs van een paar; nog niets gekozen = wat dat paar minimaal kost (dezelfde uitkomst als de Liquid). */
    function prijsVan(s) {
      var o = s.options[s.selectedIndex];
      if (o && o.value && !o.disabled) return parseInt(o.getAttribute('data-prijs'), 10) || 0;
      var laag = 0;
      Array.prototype.forEach.call(s.querySelectorAll('option[data-prijs]:not([disabled])'), function (x) {
        var p = parseInt(x.getAttribute('data-prijs'), 10);
        if (p && (!laag || p < laag)) laag = p;
      });
      return laag;
    }

    var rekenen = veilig(function () {
      var opties = gekozen();
      var compleet = opties[0] && opties[1] && opties[2];
      if (!geld) {
        /* Zonder geldformaat blijven de bedragen uit Liquid staan; de knop moet wel zeggen wat er ontbreekt. */
        if (!compleet) knopTekst.textContent = t.kiesMaat;
        return;
      }
      var prijzen = Array.prototype.map.call(keuzes, prijsVan);
      var som = prijzen[0] + prijzen[1] + prijzen[2];
      var laagste = Math.min(prijzen[0], prijzen[1], prijzen[2]);
      if (!som) return;
      if (prijs3) prijs3.textContent = geld(som - laagste);
      if (prijsWas) prijsWas.textContent = geld(som);
      if (bespaar) bespaar.textContent = t.bespaar.replace('{bedrag}', geld(laagste));
      if (perPaar) perPaar.textContent = t.perPaar.replace('{prijs}', geld(Math.round((som - laagste) / 3)));
      knopTekst.textContent = compleet ? t.knop.replace('{prijs}', geld(som - laagste)) : t.kiesMaat;
    });

    /* Zolang de klant de paren niet zelf aanpaste, volgen ze de maatknop: huidige kleur + gekozen maat.
       Geen maat, of een maat die in deze kleur uitverkocht is: dan weer leeg ("Kies kleur en maat"), nooit stil
       een andere maat. */
    var volgNative = veilig(function () {
      if (aangeraakt) return;
      var id = eigen[gekozenMaat(info)] || '';
      keuzes.forEach(function (s) {
        var o = id ? s.querySelector('option[value="' + id + '"]') : null;
        if (o && !o.disabled) s.value = id;
        else s.selectedIndex = 0;
      });
      if (id) toonFout(''); /* "Kies eerst je maat." is nu beantwoord */
      rekenen();
    });

    var modus = veilig(function (aantal) {
      drie = aantal === 3;
      info.classList.toggle('bn-sok-pak-3', drie);
      html.classList.toggle('bn-sok-pak-3', drie);
      paren.hidden = !drie;
      toonFout('');
      if (drie) volgNative();
    });

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) modus(parseInt(r.value, 10));
      });
    });

    keuzes.forEach(function (s) {
      s.addEventListener('change', veilig(function () {
        aangeraakt = true;
        toonFout('');
        rekenen();
      }));
    });

    /* Een maatknop: meteen de paren bijwerken (de aangevinkte knop staat er al), en nog eens als Wonder klaar is.
       14-10, registry #71 r3: een maatknop is een nieuwe keuze voor alle drie de paren, ook als de klant ze eerder
       zelf aanpaste (of ze via #3-paar=id,id,id binnenkwamen). Anders bleven de oude paren staan en ging er een andere
       maat de winkelwagen in dan de aangevinkte maatknop liet zien. Pas de klant daarna weer zelf een paar aan, dan
       gaat dat bij een kleurwissel gewoon mee (pakHash). */
    info.addEventListener('change', veilig(function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-options')) {
        aangeraakt = false;
        setTimeout(volgNative, 0);
      }
    }));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(volgNative, 0); }); } catch (err) {}
    }

    /* 14-10, registry #71 r3: is de aangevinkte maat in deze kleur op? (Dan blijven de paren leeg, en is "Kies eerst
       je maat." de verkeerde uitleg.) Kijkt naar onze eigen optie in de keuzelijst en naar Wonder's doorgestreepte
       maatknop. */
    function maatIsOp() {
      var maat = gekozenMaat(info);
      if (!maat) return false;
      var id = eigen[maat];
      var o = id ? keuzes[0].querySelector('option[value="' + id + '"]') : null;
      if (o && o.disabled) return true;
      var r = info.querySelector('variant-options input[type="radio"]:checked');
      return !!(r && r.classList.contains('disabled'));
    }

    function controleer() {
      var opties = gekozen();
      if (!opties[0] && !opties[1] && !opties[2]) {
        if (maatIsOp()) return { fout: t.maatOp || t.kies };
        return { fout: t.kiesEerst || t.kies };
      }
      var aantal = {};
      for (var i = 0; i < opties.length; i++) {
        var o = opties[i];
        if (!o) return { fout: t.kies };
        aantal[o.value] = (aantal[o.value] || 0) + 1;
      }
      for (var j = 0; j < opties.length; j++) {
        var v = opties[j];
        var voorraad = v.getAttribute('data-voorraad');
        if (voorraad !== '' && voorraad !== null && aantal[v.value] > parseInt(voorraad, 10)) {
          return { fout: t.teWeinig.replace('{wat}', v.getAttribute('data-naam')).replace('{n}', voorraad) };
        }
      }
      return {
        items: Object.keys(aantal).map(function (id) { return { id: parseInt(id, 10), quantity: aantal[id] }; })
      };
    }

    function laden(aan) {
      bezig = aan;
      knop.classList.toggle('loading', aan);
      if (aan) {
        knop.setAttribute('aria-disabled', 'true');
        knop.setAttribute('aria-busy', 'true');
        knopTekst.textContent = t.bezig;
      } else {
        knop.removeAttribute('aria-disabled');
        knop.removeAttribute('aria-busy');
        rekenen();
      }
    }

    function naarWinkelwagen() {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }

    function openLade(data) {
      var lade = document.querySelector('cart-drawer');
      if (!lade || lade.dataset.cartType !== 'drawer' || typeof lade.renderContents !== 'function' || !data.sections) {
        naarWinkelwagen();
        return;
      }
      try {
        lade.classList.remove('is-empty');
        lade.renderContents(data, !document.body.classList.contains('page-overlay-cart-on'));
      } catch (err) {
        naarWinkelwagen();
      }
    }

    knop.addEventListener('click', veilig(function () {
      if (bezig) return;
      var c = controleer();
      if (c.fout) {
        toonFout(c.fout);
        return;
      }
      toonFout('');
      laden(true);

      var body = { items: c.items };
      var lade = document.querySelector('cart-drawer');
      if (lade && typeof lade.getSectionsToRender === 'function') {
        try {
          body.sections = lade.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        } catch (err) {}
      }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (r) {
          if (!r.ok || r.data.status) {
            /* 422 = Shopify's eigen, vertaalde uitleg (uitverkocht, te weinig voorraad); anders onze tekst. */
            toonFout(r.data.status === 422 && r.data.description ? r.data.description : t.fout);
            return;
          }
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'burned-sock-pack', cartData: r.data });
            }
          } catch (err) {}
          openLade(r.data);
        })
        .catch(function () { toonFout(t.fout); })
        .then(function () { laden(false); });
    }));

    /* Sticky koopbalk: in 3-paar-modus naar de pakkiezer scrollen in plaats van één paar toevoegen, en
       de balk verbergen zolang de pakkiezer in beeld is (r3: de kaarten of het koopdeel).
       14-10, registry #71 r3: is "Houd me op de hoogte" (bn_voorraad) zichtbaar, dan heet de balk zo en brengt
       bn_voorraad's eigen klikhandler je naar dat formulier; dan hier niets onderscheppen. */
    window.addEventListener('click', veilig(function (e) {
      if (!html.classList.contains('bn-sok-pak-3')) return;
      var balk = e.target && e.target.closest && e.target.closest('sticky-buy-button');
      if (!balk || !e.target.closest('button')) return;
      var houdMe = info.querySelector('[data-bn-voorraad]') || document.querySelector('[data-bn-voorraad]');
      if (houdMe && !houdMe.hidden && houdMe.getClientRects().length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      blok.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }), true);
    if ('IntersectionObserver' in window) {
      var inBeeld = [];
      var io = new IntersectionObserver(veilig(function (entries) {
        entries.forEach(function (en) {
          var i = inBeeld.indexOf(en.target);
          if (en.isIntersecting && i === -1) inBeeld.push(en.target);
          if (!en.isIntersecting && i !== -1) inBeeld.splice(i, 1);
        });
        html.classList.toggle('bn-sok-pak-zicht', inBeeld.length > 0);
      }));
      io.observe(blok);
      io.observe(koop);
    }

    /* 14-10, registry #71 r3: de submit-wacht (initWacht) vraagt dit; na een terugval altijd false. */
    pakDrie = function () { return drie && !kapot; };

    /* Kleurwissel (r3): zelf aangepaste paren gaan mee, de stand (1 of 3 paar) ook. Niet aangepast = de paren
       volgen op de nieuwe pagina de maat die via ?variant= meegaat, in de nieuwe kleur. */
    pakHash = function () {
      if (!drie) return '#1-paar';
      if (!aangeraakt) return '#3-paar';
      return '#3-paar=' + Array.prototype.map.call(keuzes, function (s) {
        var o = s.options[s.selectedIndex];
        return o && o.value && !o.disabled ? o.value : '';
      }).join(',');
    };

    /* Starten. "3 paar" staat in de HTML aan; #1-paar of #3-paar(=id,id,id) van een kleurwissel gaat voor. */
    var hash = /^#([13])-paar(?:=([0-9,]*))?$/.exec(window.location.hash || '');
    if (hash) {
      radios.forEach(function (r) { r.checked = r.value === hash[1]; });
    }
    /* 14-10, registry #71 r3: welke kaart de HTML aanvinkt, bepaalt de pack-snippet (3 paar; 1 paar als dit product
       helemaal uitverkocht is). Staat er (vreemd genoeg) niets aan, dan 3. */
    var start = 3;
    radios.forEach(function (r) { if (r.checked) start = parseInt(r.value, 10); });
    blok.hidden = false;
    koop.hidden = false;
    info.classList.add('bn-sok-pak-aan');
    modus(start);
    if (kapot) return; /* terugval is al gedaan */
    if (hash && hash[1] === '3' && hash[2]) {
      /* Bestaat een id hier niet (meer), of is hij uitverkocht: dan blijft dat paar zoals de pagina het gaf. */
      var ids = hash[2].split(',');
      var terug = false;
      keuzes.forEach(function (s, i) {
        var o = ids[i] ? s.querySelector('option[value="' + ids[i] + '"]') : null;
        if (o && !o.disabled) {
          s.value = ids[i];
          terug = true;
        }
      });
      if (terug) aangeraakt = true;
    }
    rekenen();
  }

  /* De terugval van de pakkiezer: weg ermee, en Wonder's koopknop en aantalkiezer terug (die verbergt burned-sock.css
     alleen via de klassen bn-sok-pak-3 en bn-sok-pak-aan). Bij een opstartfout (start) en, sinds 14-10 (registry #71
     r3), ook bij een fout daarna (veilig() in initPak). Daarna is het een gewone Wonder-productpagina: 1 paar. */
  function terugval(blok, err) {
    blok.hidden = true;
    var info = blok.closest('.wt-product__info');
    var koop = info && info.querySelector('[data-bn-sok-pak-koop]');
    if (koop) koop.hidden = true;
    if (info) info.classList.remove('bn-sok-pak-3', 'bn-sok-pak-aan');
    html.classList.remove('bn-sok-pak-3', 'bn-sok-pak-zicht');
    pakHash = function () { return ''; };
    pakDrie = function () { return false; };
    console.warn('burned-sock pakkiezer', err);
  }

  /* ---------- Submit-wacht (14-10, registry #71 r3) ----------
     Capture op document, dus vóór Wonder's eigen submit-handler (product-form.js luistert op het formulier zelf).
     Wonder's productformulier gaat niet de deur uit als (a) de pakkiezer op 3 paar staat én Wonder's koopknop
     daardoor echt verborgen is (Enter op een maatknop of een synthetische klik verkocht anders stil 1 paar), of (b) er
     geen maatknop aangevinkt is (dan staat in name="id" Wonder's eerste leverbare maat, niet de keuze van de klant).
     Bij (a) eerst kijken of de knop echt weg is: laadt burned-sock.css niet, dan staat Wonder's knop gewoon in beeld
     en moet een klik erop 1 paar verkopen (vangnet). Alleen dit script: valt het weg of gooit de controle een fout,
     dan doet Wonder gewoon zijn werk. */
  function initWacht(info) {
    document.addEventListener('submit', function (e) {
      try {
        var f = e.target;
        var houder = f && f.closest && f.closest('.main-product__buy-buttons--container');
        if (!houder || !f.matches('form[action*="/cart/add"]') || !info.contains(f)) return;
        var drieVerborgen = pakDrie() && !houder.getClientRects().length;
        var zonderMaat = heeftMaatknoppen(info) && !gekozenMaat(info);
        if (!drieVerborgen && !zonderMaat) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (zonderMaat && !drieVerborgen) meldKiesMaat();
      } catch (err) { /* bij twijfel: Wonder laten doen */ }
    }, true);
  }

  /* ---------- r5 (16-10): "Maattabel" rechts naast "Sokmaten EU:" → anker naar de maattabel ----------
     Staat de sectie burned-sock-maat op de pagina (#bn-maat), dan komt in de maatoptie de link uit de <template
     data-bn-maatlink> van de maathulp (zelfde markup als Wonder's maatgids-slot: icoon + link). Wonder's eigen slot
     (variant_picker: variant_name "Sokmaten EU", alleen nl; en/fr vertalen de optienaam) gaat daarbij weg, inclusief
     de lege pop-up. De maatoptie herkennen we aan de knopwaarden (de maatnamen uit data-maten: S, M, L, XL), niet
     aan de naam. Zonder de sectie gebeurt er niets; zonder script verbergt Wonder zijn knop zelf (no-js-hidden). */
  function initMaatlink(hulp) {
    var doel = document.getElementById('bn-maat');
    if (!doel) return;
    var info = hulp.closest('.wt-product__info');
    if (!info || info.querySelector('a.bn-sok-maatlink')) return;
    var tpl = info.querySelector('template[data-bn-maatlink]');
    if (!tpl || !tpl.content) return;
    var namen = (doel.getAttribute('data-maten') || '').split(',').map(function (s) { return s.split(':')[0]; });
    if (!namen.length || !namen[0]) return;
    var wrapper = null;
    info.querySelectorAll('.wt-product__option').forEach(function (opt) {
      if (wrapper) return;
      var waarden = [].slice.call(opt.querySelectorAll('input[type="radio"], option')).map(function (i) {
        return String(i.value || '').toUpperCase().replace(/[^A-Z].*$/, '');
      });
      var past = namen.every(function (n) { return waarden.indexOf(n) > -1; });
      if (past) wrapper = opt.querySelector('.wt-product__option__wrapper');
    });
    if (!wrapper) return;
    info.querySelectorAll('.wt-product__option__size-guide').forEach(function (slot) {
      var opener = slot.querySelector('modal-opener');
      var modal = null;
      try { modal = opener && document.querySelector(opener.getAttribute('data-modal')); } catch (err) {}
      if (modal && modal.parentNode) modal.parentNode.removeChild(modal);
      slot.parentNode.removeChild(slot);
    });
    wrapper.appendChild(tpl.content.cloneNode(true));
  }

  function start() {
    document.querySelectorAll('[data-bn-sok-kleur]').forEach(function (blok) {
      try { initKleur(blok); } catch (err) { console.warn('burned-sock kleur', err); }
    });
    /* 14-10, registry #71 r3: elke maathulp (ook de en fr, voor de lege maatnaam en de zwarte knop); de knoptekst
       zelf alleen waar data-bn-kies-maat staat (nl, en). */
    document.querySelectorAll('[data-bn-sok-maathulp]').forEach(function (hulp) {
      try {
        initKiesMaat(hulp);
      } catch (err) {
        var i = hulp.closest('.wt-product__info');
        if (i) i.classList.remove('bn-sok-kies-maat');
        meldKiesMaat = function () {};
        console.warn('burned-sock knoptekst', err);
      }
      try { initMaatlink(hulp); } catch (err) { console.warn('burned-sock maatlink', err); }
    });
    var eigen = document.querySelector('[data-bn-sok-maathulp], [data-bn-sok-kleur], [data-bn-sok-pak]');
    var info = eigen && eigen.closest('.wt-product__info');
    if (info) {
      try { initKolom(info); } catch (err) { console.warn('burned-sock kolom', err); }
    }
    document.querySelectorAll('[data-bn-sok-pak]').forEach(function (blok) {
      try {
        initPak(blok);
      } catch (err) {
        terugval(blok, err);
      }
    });
    if (info) {
      try { initWacht(info); } catch (err) { console.warn('burned-sock wacht', err); }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
